/*************************
 * Author : Matthieu ROBIN
 *************************/
import React, { FunctionComponent } from "react";
import { AddAPhoto } from "@mui/icons-material";
import { Box, Fab } from "@mui/material";

type ImagePickerProps = {
  name?: string;
  placeholder?: string;
  onChange?: (event: File) => void;
};

const ImagePicker: FunctionComponent<ImagePickerProps> = React.forwardRef<
  HTMLInputElement,
  ImagePickerProps
>(({ name, placeholder, onChange }, ref) => {
  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      <img
        alt=""
        src={placeholder}
        style={{
          width: "100%",
          height: undefined,
          objectFit: "contain",
          aspectRatio: 4 / 3,
        }}
      />

      <label htmlFor={name} style={{ position: "absolute" }}>
        <input
          ref={ref}
          accept="image/*"
          capture="environment"
          id={name}
          style={{ display: "none" }}
          type="file"
          onChange={(e) => {
            onChange(e.target.files[0]);
          }}
        />
        <Fab aria-label="add image" color="primary" component="span">
          <AddAPhoto />
        </Fab>
      </label>
    </Box>
  );
});

export default ImagePicker;
